// extracted by mini-css-extract-plugin
module.exports = {"section":"JzJqP","image":"qhdek","text":"_3NWsQ","imageImg":"_2xcSB","textName":"_3AqrD","logo":"_2cDLE","logoImg":"_3InxI","sticky":"_3SQew","stickyContent":"iq2zT"};